import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  ChevronDown,
  ChevronUp,
  FileText,
  BookOpen,
  Stethoscope,
  Activity
} from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";

const API_BASE = "https://newerp.awasthivitality.com/api";

const AddCourse = () => {
  const navigate = useNavigate();
  const { patient_id } = useParams();

  const [formData, setFormData] = useState({
    courseType: "",
    courseDate: "",
    diagnosis: "",
    diagnosisCode: "",
    serviceType: "",
    remark: "",
    remark4: "",
    selectedSymptoms: [],
    remark2: "",
    remark42: "",

    // selectedSymptoms: [],
    selectedSymptoms2: []

  });

  const [productsByDiagnosis, setProductsByDiagnosis] = useState([]);
  const [selectedMedicines, setSelectedMedicines] = useState([]);
  const [productsByDiagnosis2, setProductsByDiagnosis2] = useState([]);
  const [selectedMedicines2, setSelectedMedicines2] = useState([]);

  const [symptoms2, setSymptoms2] = useState([]);
  const [errors, setErrors] = useState({});
  const [diagnoses, setDiagnoses] = useState([]);
  const [symptoms, setSymptoms] = useState([]);
  const [loadingDiagnoses, setLoadingDiagnoses] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  /* 🟢 NEW: Last course state */
  const [lastCourse, setLastCourse] = useState(null);
  const [autoFilled, setAutoFilled] = useState(false);
  const groupedMedicines = productsByDiagnosis.reduce((acc, item) => {
    const letter = item.product_name
      ? item.product_name.charAt(0).toUpperCase()
      : "#";

    if (!acc[letter]) acc[letter] = [];
    acc[letter].push(item);

    return acc;
  }, {});
  const groupedMedicines2 = productsByDiagnosis2.reduce((acc, item) => {

    const letter = item.product_name
      ? item.product_name.charAt(0).toUpperCase()
      : "#";

    if (!acc[letter]) acc[letter] = [];

    acc[letter].push(item);

    return acc;

  }, {});

  const sortedLetters2 = Object.keys(groupedMedicines2).sort();

  const sortedLetters = Object.keys(groupedMedicines).sort();

  /* ===============================
     SET TODAY DATE
  ================================ */
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setFormData(prev => ({ ...prev, courseDate: today }));
  }, []);

  /* ===============================
     FETCH LAST COURSE (AUTOFILL)
     🔴 UPDATED
  ================================ */
  useEffect(() => {
    if (!patient_id) return;

    const token = localStorage.getItem("session_token");

    fetch(`${API_BASE}/patient/view/${patient_id}?token=${token}`, {
      cache: "no-store" // ⛔ prevent cached data
    })
      .then(res => res.json())
      .then(res => {
        const courses = res?.data?.courses || [];

        if (courses.length > 0) {
          // 🔥 Sort by latest (ID or date)
          const sorted = [...courses].sort(
            (a, b) => new Date(b.course_date) - new Date(a.course_date)
          );

          setLastCourse(sorted[0]); // ✅ always latest
          setAutoFilled(false);     // allow re-autofill
        }
      })
      .catch(err => console.error("Patient view error", err));
  }, [patient_id]);


  /* ===============================
     APPLY AUTOFILL ONCE
     🔴 UPDATED
  ================================ */
  useEffect(() => {
    if (!lastCourse || autoFilled) return;

    setFormData(prev => ({
      ...prev,
      diagnosis: lastCourse.diagnosis_id?.toString() || "",
      serviceType: lastCourse.service_type || "",
      remark: lastCourse.remark || "",
      remark4: lastCourse.remark4 || "",
      selectedSymptoms: JSON.parse(lastCourse.sign_symptom_all || "[]").map(Number)
    }));

    // setSelectedMedicines(lastCourse.medicine_names || []);
    setAutoFilled(true);
  }, [lastCourse, autoFilled]);

  /* ===============================
     FETCH DIAGNOSES
  ================================ */
  useEffect(() => {
    fetch(`${API_BASE}/diagnosis/options`)
      .then(res => res.json())
      .then(data => {
        if (data.success) setDiagnoses(data.data);
      })
      .finally(() => setLoadingDiagnoses(false));
  }, []);

  /* ===============================
     LOAD SYMPTOMS ON DIAGNOSIS CHANGE
  ================================ */
  useEffect(() => {
    if (!formData.diagnosis) {
      setSymptoms([]);
      return;
    }

    const diag = diagnoses.find(
      d => d.diagnosis_id === parseInt(formData.diagnosis)
    );

    setSymptoms(diag?.symptoms || []);
  }, [formData.diagnosis, diagnoses]);
  useEffect(() => {
    if (!formData.diagnosis2) {
      setSymptoms2([]);
      return;
    }

    const diag = diagnoses.find(
      d => d.diagnosis_id === parseInt(formData.diagnosis2)
    );

    setSymptoms2(diag?.symptoms || []);

  }, [formData.diagnosis2, diagnoses]);
  useEffect(() => {

    if (!formData.diagnosis2) return;

    fetch(`${API_BASE}/products-by-diagnosis/${formData.diagnosis2}`)
      .then(res => res.json())
      .then(res => setProductsByDiagnosis2(res.data || []))
      .catch(() => setProductsByDiagnosis2([]));

  }, [formData.diagnosis2]);
  /* ===============================
     FETCH MEDICINES
  ================================ */
  useEffect(() => {
    if (!formData.diagnosis) return;

    fetch(`${API_BASE}/products-by-diagnosis/${formData.diagnosis}`)
      .then(res => res.json())
      .then(res => setProductsByDiagnosis(res.data || []))
      .catch(() => setProductsByDiagnosis([]));
  }, [formData.diagnosis]);

  /* ===============================
     HANDLE CHANGE
     🔴 UPDATED (manual override)
  ================================ */
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({ ...prev, [name]: value }));

    if (name === "diagnosis") {
      setFormData(prev => ({ ...prev, selectedSymptoms: [] }));
      setSelectedMedicines([]);
    }

    if (errors[name]) {
      setErrors(prev => {
        const copy = { ...prev };
        delete copy[name];
        return copy;
      });
    }
  };

  /* ===============================
     VALIDATION
  ================================ */
  const validate = () => {
    const err = {};
    if (!formData.courseDate) err.courseDate = "Required";
    if (!formData.diagnosis) err.diagnosis = "Required";
    if (!formData.serviceType) err.serviceType = "Required";
    if (!formData.selectedSymptoms.length) err.symptoms = "Select symptom";

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  /* ===============================
     SUBMIT
  ================================ */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setIsSubmitting(true);

    const payload = {
      course_date: formData.courseDate,
      service_type: formData.serviceType,
      diagnosis_id: parseInt(formData.diagnosis),
      diagnosis_code: formData.diagnosisCode,
      remark: formData.remark,
      remark4: formData.remark4,
      sign_symptom_all: formData.selectedSymptoms,
      medicine_names: selectedMedicines,
      diagnosis_symptom_id: formData.selectedSymptoms[0] || 0,
      diagnosis_id2: formData.diagnosis2
        ? parseInt(formData.diagnosis2)
        : null,

      remark2: formData.remark2,
      remark42: formData.remark42,
      sign_symptom_all2: formData.selectedSymptoms2,
      medicine_names2: selectedMedicines2,

      // diagnosis_symptom_id: formData.selectedSymptoms[0] || 0
    };

    try {
      const res = await fetch(
        `${API_BASE}/patient/${patient_id}/add-diagnosis`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        }
      );

      const result = await res.json();
      if (result.success) {
        toast.success("Diagnosis saved");
        setTimeout(() => navigate(-1), 1000);
      } else {
        toast.error(result.message || "Error");
      }
    } catch {
      toast.error("Network error");
    } finally {
      setIsSubmitting(false);
    }
  };

  /* ===============================
     UI (UNCHANGED)
  ================================ */
  return (
    <div className="app-container">
      <ToastContainer position="top-right" autoClose={3000} />

      <style>{`:root{
   --primary-bg-color: #f6f8fb;
   --main-card-bg-color: #ffffff;
   --main-card-border-color: #e6e9ef;
   --main-card-shadow: 0 16px 30px rgba(15,23,42,0.06);
   --header-border-color: #f1f4f3;
   --header-title-color: #0f172a;
   --text-color: #374151;
   --accent-color: #06b6d4;
   --button-gradient-start: #38bdf8;
   --button-gradient-end: #2dd4bf;
   --button-hover-gradient-start: #0ea5e9;
   --button-hover-gradient-end: #14b8a6;
   --section-gradient-start: #06b6d4;
   --section-gradient-end: #f1f4f3;
   --submit-button-gradient-start: #fb923c;
   --submit-button-gradient-end: #f59e0b;
   --submit-button-hover-gradient-start: #f97316;
   --submit-button-hover-gradient-end: #eab308;
   --input-border-color: #d1d5db;
   --input-bg-color: #ffffff;
   --input-muted-bg: #f8fafc;
   --input-focus-color: rgba(6,182,212,0.18);
   --error-color: #ef4444;
   --success-color: #10b981;
   --warning-color: #f59e0b;
   --info-color: #3b82f6;
   --radius-sm: 6px;
   --radius-md: 12px;
 }
 
 *{box-sizing: border-box}
 body { font-family: Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial; margin:0; padding:0; color:var(--text-color); }
 
 .app-container {
   min-height: 100vh;
   background: linear-gradient(135deg, #f6f8fb 0%, #eef2f7 50%, #f6f8fb 100%);
   background-size: 200% 200%;
   display: flex;
   justify-content: center;
   align-items: flex-start;
   padding: 1rem;
 }
 
 @media (min-width: 640px) {
   .app-container { padding: 1.5rem; }
 }
 
 .main-card {
   width: 100%;
   max-width: 100%;
   margin: 0 auto;
   background: var(--main-card-bg-color);
   border-radius: var(--radius-md);
   box-shadow: var(--main-card-shadow);
   border: 1px solid var(--main-card-border-color);
   overflow: hidden;
 }
 
 .header {
   display: flex;
   flex-direction: column;
   gap: 0.15rem; /* smaller vertical spacing */
   padding: 0.5rem 1rem; /* 👈 reduced header height */
   border-bottom: 2px solid var(--header-border-color); /* thinner line */
   background: linear-gradient(180deg, rgba(255,255,255,0.7), rgba(255,255,255,0.95));
 }
 
 
 @media (min-width: 640px) {
   .header { flex-direction: row; align-items: center; justify-content: space-between; }
 }
 
 .header-title { display:flex; align-items:center; gap:0.5rem; font-size:1.25rem; font-weight:800; color:var(--header-title-color); }
 .header-title .icon { color: var(--accent-color); }
 
 .header-nav { display:flex; gap:1rem; align-items:center; font-size:0.95rem; color:var(--text-color); }
 .header-nav .current-page { color: var(--accent-color); font-weight:700; }
 
 .header-button {
   background-image: linear-gradient(90deg, var(--button-gradient-start), var(--button-gradient-end));
   color: white;
   padding: 0.5rem 0.9rem;
   border-radius: 8px;
   border: none;
   cursor: pointer;
   font-weight:600;
   box-shadow: 0 6px 18px rgba(3,105,161,0.06);
   transition: transform .18s ease, filter .18s ease;
 }
 .header-button:hover { transform: translateY(-2px); filter:brightness(1.02); }
 
 .main-content { padding: 1rem; }
 
 form { width:100%; }
 
 .form-meta {
   display:flex;
   gap:1rem;
   flex-direction:column;
   margin-bottom:1.25rem;
   align-items:flex-start;
 }
 @media (min-width:640px) {
   .form-meta { flex-direction:row; justify-content:space-between; align-items:flex-end; }
 }
 
 .label-group { display:flex; flex-direction:column; gap:0.5rem; }
 .label-text { font-weight:600; color:#0f172a; font-size:0.95rem; }
 
 .radio-group { display:flex; gap:1rem; align-items:center; color:var(--text-color); }
 .radio-label { display:flex; align-items:center; gap:0.5rem; cursor:pointer; user-select:none; }
 .radio-input { width:18px; height:18px; accent-color: var(--accent-color); }
 
 .date-input {
   padding:0.5rem;
   border-radius:8px;
   border:1px solid var(--input-border-color);
   background:var(--input-muted-bg);
   box-shadow: 0 1px 0 rgba(16,24,40,0.02);
 }
 .date-input:focus { outline: none; box-shadow: 0 0 0 4px var(--input-focus-color); border-color: var(--accent-color); }
 
 .form-section-container { margin-bottom:1.25rem; }
 .form-section-header {
   display:flex;
   justify-content:space-between;
   align-items:center;
   gap:1rem;
   padding:0.95rem 1rem;
   border-radius: 10px 10px 0 0;
   background-image: linear-gradient(90deg, var(--section-gradient-start), var(--section-gradient-end));
   color: white;
   cursor: pointer;
   box-shadow: 0 8px 20px rgba(3,105,161,0.06);
   transition: transform .14s ease, box-shadow .14s ease;
 }
 .form-section-header:hover { transform: translateY(-3px); }
 .header-content { display:flex; align-items:center; gap:0.6rem; }
 .section-title { font-weight:600; font-size:1rem; margin:0; }
 
 .form-section-body {
   padding:1.25rem;
   border:1px solid var(--main-card-border-color);
   border-top: none;
   background: var(--main-card-bg-color);
   border-radius: 0 0 10px 10px;
 }
 
 .form-section {
   background: linear-gradient(145deg, rgba(246, 248, 251, 0.5), rgba(255, 255, 255, 0.95));
   border-radius: 12px;
   margin-bottom: 1.5rem;
   border: 1px solid rgba(230, 233, 239, 0.8);
   box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
 }
 
 .form-section-title {
   font-size: 1.5rem;
   font-weight: 900;
   color: var(--accent-color);
   margin: 0 0 1.5rem 0;
   text-transform: uppercase;
   letter-spacing: 1px;
   display: flex;
   align-items: center;
   gap: 0.75rem;
   padding: 0.5rem 1.5rem;
   background: linear-gradient(135deg, rgba(6, 182, 212, 0.15) 0%, rgba(8, 145, 178, 0.1) 100%);
   border-left: 5px solid var(--accent-color);
   border-radius: 8px;
   box-shadow: 0 4px 16px rgba(6, 182, 212, 0.15);
   text-align: left;
 }
 
 .form-section-title .section-icon {
   width: 28px;
   height: 28px;
   color: var(--accent-color);
 }
 
 .diagnosis-block {
   padding: 1.5rem;
   background: linear-gradient(145deg, rgba(255, 255, 255, 0.95), rgba(246, 248, 251, 0.6));
   border-radius: 12px;
   border: 2px solid rgba(6, 182, 212, 0.2);
   box-shadow: 0 6px 20px rgba(6, 182, 212, 0.12);
   margin-bottom: 1.5rem;
 }
 
 .form-grid {
   display: grid;
   grid-template-columns: repeat(4, 1fr);
   gap: 1rem;
   align-items: flex-start;
 }
 
 .form-grid > div {
   display: flex;
   flex-direction: column;
   min-width: 0; /* prevents grid overflow issues */
 }
 
 .form-field-label {
   display: block;
   font-weight: 600;
   font-size: 14px;
   margin-bottom: 4px;
 }
 
 .form-field-input,
 .form-field-select {
   width: 100%;
   padding: 6px 8px;
   border: 1px solid #ccc;
   border-radius: 6px;
   font-size: 14px;
 }
 
 .required-star {
   color: red;
 }
 
 /* Responsive layout for smaller devices */
 @media (max-width: 992px) {
   .form-grid {
     grid-template-columns: repeat(2, 1fr);
   }
   .form-grid > div[style*="grid-column: span 2"] {
     grid-column: span 2;
   }
 }
 
 @media (max-width: 600px) {
   .form-grid {
     grid-template-columns: 1fr;
   }
   .form-grid > div[style*="grid-column: span 2"] {
     grid-column: span 1;
   }
 }
 
 .form-field-label { display:block; margin-bottom:0.35rem; font-weight:600; color:var(--text-color); font-size:0.92rem; }
 .form-field-input,
 .form-field-select,
 .form-field-textarea {
   width:100%;
   padding:0.55rem;
   border-radius:8px;
   border:1px solid var(--input-border-color);
   background:var(--input-bg-color);
   transition: box-shadow .16s ease, border-color .16s ease;
   font-size:0.95rem;
 }
 .form-field-select { background: #fff; }
 .form-field-input:focus,
 .form-field-select:focus,
 .form-field-textarea:focus {
   outline:none;
   border-color: var(--accent-color);
   box-shadow: 0 0 0 5px var(--input-focus-color);
 }
 .required-star { color: var(--error-color); margin-left:4px; font-weight:700; }
 
 .radio-field-group { display:flex; flex-wrap:wrap; gap:1rem; margin-top:0.35rem; }
 .radio-field-label { display:flex; align-items:center; gap:0.55rem; cursor:pointer; }
 
 .textarea-field { min-height:72px; resize:vertical; }
 
 .info-note { font-size:0.8rem; color:#6b7280; margin-top:0.35rem; }
 
 .section-block {
   display:flex;
   gap:0.75rem;
   align-items:center;
   padding:0.9rem 1rem;
   border-radius:10px;
   background-image: linear-gradient(90deg, rgba(6,182,212,0.08), rgba(16,185,129,0.06));
   border:1px solid rgba(16,185,129,0.06);
   margin-bottom:1rem;
 }
 
 .upload-reports-container {
   padding:1rem;
   border:1px solid var(--main-card-border-color);
   background:var(--main-card-bg-color);
   border-radius:0 0 10px 10px;
   margin-bottom:1rem;
 }
 .upload-reports-container input[type="file"] { color: #374151; }
 
 .image-upload-container {
   padding: 0;
   background: transparent;
   border-radius: 8px;
   margin-bottom: 0;
 }
 
 .image-upload-wrapper { display: flex; flex-direction: column; gap: 1rem; }
 .image-preview { max-width: 200px; max-height: 200px; border-radius: 8px; border: 2px solid var(--input-border-color); object-fit: cover; }
 .image-upload-input { padding: 0.5rem; border: 1px solid var(--input-border-color); border-radius: 8px; background: var(--input-bg-color); color: var(--text-color); }
 .image-upload-input:focus { outline: none; border-color: var(--accent-color); box-shadow: 0 0 0 3px var(--input-focus-color); }
 
 .mobile-validation { margin-top: 0.5rem; font-size: 0.85rem; display: flex; align-items: center; gap: 0.5rem; }
 .mobile-validation.loading { color: var(--warning-color); }
 .mobile-validation.success { color: var(--success-color); }
 .mobile-validation.info { color: var(--info-color); }
 .mobile-validation.error { color: var(--error-color); }
 .mobile-validation-icon { width: 16px; height: 16px; }
 
 .existing-patient-info {
   margin-top: 0.75rem;
   padding: 1rem;
   background: linear-gradient(145deg, #eff6ff 0%, #dbeafe 100%);
   border: 2px solid #3b82f6;
   border-left: 5px solid #3b82f6;
   border-radius: 12px;
   font-size: 0.85rem;
   box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
   width: 100%;
 }
 .existing-patient-info h4 { 
   margin: 0 0 0.75rem 0; 
   color: #1e40af; 
   font-size: 1rem;
   font-weight: 700;
   display: flex;
   align-items: center;
   gap: 0.5rem;
   padding-bottom: 0.5rem;
   border-bottom: 2px solid rgba(59, 130, 246, 0.2);
 }
 .existing-patient-info .patients-grid {
   display: grid;
   grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
   gap: 0.75rem;
   margin-bottom: 0.75rem;
 }
 .existing-patient-info .patient-card {
   padding: 0.75rem;
   background: rgba(255, 255, 255, 0.7);
   border-radius: 8px;
   border: 1px solid rgba(59, 130, 246, 0.2);
   box-shadow: 0 2px 6px rgba(59, 130, 246, 0.1);
   transition: all 0.2s ease;
 }
 .existing-patient-info .patient-card:hover {
   background: rgba(255, 255, 255, 0.9);
   box-shadow: 0 4px 8px rgba(59, 130, 246, 0.15);
   transform: translateY(-1px);
 }
 .existing-patient-info .patient-card p {
   margin: 0.25rem 0;
   color: #1e3a8a;
   line-height: 1.4;
   font-size: 0.85rem;
 }
 .existing-patient-info .patient-card p strong {
   color: #1e40af;
   font-weight: 700;
   margin-right: 0.4rem;
 }
 .existing-patient-info .note-message {
   margin-top: 0.75rem;
   padding: 0.75rem;
   background: rgba(255, 255, 255, 0.8);
   border-radius: 8px;
   border-left: 4px solid #10b981;
   color: #065f46;
   font-weight: 600;
   font-size: 0.85rem;
 }
 .existing-patient-info .note-message strong {
   color: #059669;
 }
 
 @media (max-width: 768px) {
   .existing-patient-info .patients-grid {
     grid-template-columns: 1fr;
   }
 }
 
 .loading-text { color: var(--warning-color); font-style: italic; }
 
 .submit-button-container { display:flex; justify-content:flex-end; padding:1rem 0; background:transparent; border-radius:0 0 12px 12px; }
 .submit-button {
   background-image: linear-gradient(90deg, var(--submit-button-gradient-start), var(--submit-button-gradient-end));
   color:white;
   padding:0.7rem 1.6rem;
   border-radius:10px;
   border:none;
   font-weight:800;
   cursor:pointer;
   box-shadow: 0 12px 30px rgba(249,115,22,0.10);
   transition: transform .14s ease, filter .14s ease;
 }
 .submit-button:hover { transform: translateY(-3px); filter:brightness(1.02); }
 .submit-button:disabled {
   opacity: 0.6;
   cursor: not-allowed;
   transform: none;
   filter: none;
 }
 
 .error-message { color: var(--error-color); font-size: 0.85rem; margin-top: 0.25rem; }
 
 .symptoms-container {
   margin-top: 1.5rem;
   padding: 1.5rem;
   border: 2px solid rgba(6, 182, 212, 0.2);
   border-radius: 12px;
   background: linear-gradient(145deg, rgba(246, 248, 251, 0.8), rgba(255, 255, 255, 0.95));
   box-shadow: 0 4px 12px rgba(6, 182, 212, 0.1);
 }
 
 .symptoms-container h3 {
   font-size: 1.2rem;
   font-weight: 800;
   color: var(--accent-color);
   margin: 0 0 1rem 0;
   display: flex;
   align-items: center;
   gap: 0.5rem;
   padding-bottom: 0.75rem;
   border-bottom: 2px solid rgba(6, 182, 212, 0.2);
 }
 
 .symptoms-container h3 .section-icon {
   width: 24px;
   height: 24px;
   color: var(--accent-color);
 }
 .symptoms-grid {
   display: grid;
   grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
   gap: 0.75rem;
   margin-top: 0.75rem;
 }
 .symptom-checkbox-label { display: flex; align-items: center; gap: 0.5rem; cursor: pointer; padding: 0.5rem; border-radius: 6px; transition: background-color 0.2s ease; }
 .symptom-checkbox-label:hover { background-color: rgba(6, 182, 212, 0.05); }
 .symptom-checkbox { width: 16px; height: 16px; accent-color: var(--accent-color); }
 
 .horizontal-form { 
   display: grid;
   grid-template-columns: repeat(3, 1fr);
   gap: 2rem;
   align-items: flex-start;
   background: linear-gradient(145deg, rgba(249, 251, 253, 0.6), rgba(255, 255, 255, 0.95));
   border-radius: 10px;
   border: 1px solid rgba(230, 233, 239, 0.6);
   margin-bottom: 1.5rem;
 }
 .alphabet-wrapper {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.alphabet-header {
  background: #f1f5f9;
  padding: 8px 14px;
  font-weight: 700;
  border-radius: 8px;
  margin-bottom: 10px;
  color: #334155;
}

.symptoms-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 10px;
}

.symptom-checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 20px;
  background: #fff;
  cursor: pointer;
  transition: 0.2s ease;
}

.symptom-checkbox-label:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

 @media (max-width: 768px) {
   .horizontal-form {
     grid-template-columns: 1fr;
     gap: 1.5rem;
   }
 }
 .form-item { display: flex; flex-direction: column; }
 .two-column-row { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
 
 .add-diagnosis-button {
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   gap: 0.75rem;
   margin: 2rem auto;
   padding: 0;
 }
 
 .add-diagnosis-btn {
   display: inline-flex;
   align-items: center;
   justify-content: center;
   gap: 0.5rem;
   background: linear-gradient(135deg, var(--accent-color) 0%, #0891b2 100%);
   color: white;
   border: none;
   border-radius: 12px;
   font-size: 1rem;
   font-weight: 700;
   cursor: pointer;
   box-shadow: 0 4px 16px rgba(6, 182, 212, 0.3);
   transition: all 0.3s ease;
   min-width: 220px;
 }
 
 .add-diagnosis-btn:hover {
   transform: translateY(-2px);
   box-shadow: 0 6px 24px rgba(6, 182, 212, 0.4);
   background: linear-gradient(135deg, #0891b2 0%, var(--accent-color) 100%);
 }
 
 .add-diagnosis-btn:active {
   transform: translateY(0);
   box-shadow: 0 2px 8px rgba(6, 182, 212, 0.3);
 }
 
 .add-diagnosis-btn .btn-icon {
   width: 20px;
   height: 20px;
 }
 .symptom-text { font-size: 0.9rem; color: var(--text-color); }
 /* 👇 Make Age field narrower */
 .small-age-input {
   width: 80px;
 }
 .highlight-box {
   background: linear-gradient(145deg, #f9fbfd, #f0f4f8);
   border: 1px solid #e3e8ef;
   border-radius: 12px;
   padding: 1.5rem;
   margin-bottom: 1.75rem;
   box-shadow: 0 8px 16px rgba(15, 23, 42, 0.06);
   transition: all 0.3s ease;
 }
 
 .highlight-box:hover {
   background: linear-gradient(145deg, #f8fafc, #edf2f7);
   transform: translateY(-2px);
   box-shadow: 0 10px 20px rgba(15, 23, 42, 0.1);
 }
 .patient-info-row {
   display: flex;
   flex-wrap: wrap;
   gap: 1rem;
   align-items: flex-start;
 }
 
 .patient-info-row > div {
   display: flex;
   flex-direction: column;
   width: auto;
 }
 
 .patient-info-row .form-field-input,
 .patient-info-row .form-field-select {
   width: 128px; /* 👈 small input boxes */
   padding: 6px 8px;
   border: 1px solid #ccc;
   border-radius: 6px;
   font-size: 14px;
 }
 
 .patient-info-row .form-field-label {
   font-size: 13px;
   font-weight: 500;
   margin-bottom: 4px;
 }
 
 .address-info-row {
   display: flex;
   flex-wrap: wrap;
   gap: 1rem;              /* spacing between fields */
   align-items: flex-end;  /* aligns labels nicely at bottom */
 }
 
 .address-info-row > div {
   display: flex;
   flex-direction: column;
   width: auto;
 }
 
 .address-info-row .form-field-input,
 .address-info-row .form-field-select {
   width: 140px; /* 👈 small input width */
   padding: 6px 8px;
   border: 1px solid #ccc;
   border-radius: 6px;
   font-size: 14px;
 }
 
 /* Make the Address field a bit wider */
 .address-info-row input[name="address"] {
   width: 500px;
 }
 
 .address-info-row .form-field-label {
   font-size: 13px;
   font-weight: 500;
   margin-bottom: 4px;
 }
 .diagnosis-row {
   display: flex;
   gap: 1rem;
   flex-wrap: wrap; /* allows responsiveness */
 }
 
 .diagnosis-row > div {
   flex: 1;
   min-width: 200px;
 }
 
 /* ------------------------------------------ */
 /* MOBILE RESPONSIVE (ONLY FOR < 768px)       */
 /* ------------------------------------------ */
 @media (max-width: 768px) {
 
   .main-card {
     padding: 10px !important;
   }
 
   .header {
     flex-direction: column;
     align-items: flex-start;
     gap: 10px;
   }
 
   .form-grid,
   .patient-info-row,
   .diagnosis-row,
   .address-info-row {
     display: grid !important;
     grid-template-columns: 1fr !important;   /* Convert to single column */
     gap: 15px !important;
   }
 
   /* Input full width */
   .form-field-input,
   .form-field-select,
   .date-input {
     width: 100% !important;
   }
 
   /* Radio groups vertical */
   .horizontal-form {
     flex-direction: column !important;
     gap: 20px !important;
   }
 
   .radio-field-group {
     flex-direction: row;
     gap: 15px;
     flex-wrap: wrap;
   }
 
   /* Symptoms grid adjust */
   .symptoms-grid {
     grid-template-columns: 1fr !important;
   }
 
   /* Service mode buttons */
   .form-section div[style*="justify-content: space-between"] {
     flex-direction: column !important;
     align-items: flex-start !important;
     gap: 10px !important;
   }
 
   /* Existing patient cards single column */
   .patients-grid {
     grid-template-columns: 1fr !important;
   }
 
   .image-preview {
     width: 100% !important;
     max-height: 280px;
     object-fit: cover;
   }
 
   .submit-button-container {
     text-align: center;
   }
 
   .submit-button {
     width: 100%;
   }
 }`}</style>
      <div className="main-card">
        <header className="header">
          <h1 className="header-title">
            <BookOpen className="icon" />
            Add Diagnosis To Patient
          </h1>
          <div className="form-meta">
            <div>
              <label className="label-text">
                Course Date <span className="required-star">*</span>
              </label>
              <input
                type="date"
                name="courseDate"
                value={formData.courseDate}
                onChange={handleChange}
                className="date-input"
                required
              />
              {errors.courseDate && <p className="error-message">{errors.courseDate}</p>}
            </div>
          </div>
        </header>

        <main className="main-content">
          <form onSubmit={handleSubmit}>
            <div className="form-section">
              <h2 className="form-section-title">
                <Stethoscope className="section-icon" size={28} />
                Diagnosis Details
              </h2>

              <div className="form-grid diagnosis-row">
                <div>
                  <label className="form-field-label">
                    Diagnosis <span className="required-star">*</span>
                  </label>
                  <select
                    name="diagnosis"
                    value={formData.diagnosis}
                    onChange={handleChange}
                    className="form-field-select"
                    disabled={loadingDiagnoses}
                    required
                  >
                    <option value="">
                      {loadingDiagnoses ? "Loading diagnoses..." : "Select Diagnosis"}
                    </option>
                    {diagnoses.map((diag) => (
                      <option key={diag.diagnosis_id} value={diag.diagnosis_id}>
                        {diag.name}
                      </option>
                    ))}
                  </select>
                  {errors.diagnosis && <p className="error-message">{errors.diagnosis}</p>}
                </div>



                <div>
                  <label className="form-field-label">Dosing</label>
                  <input
                    type="text"
                    name="remark"
                    value={formData.remark}
                    onChange={handleChange}
                    className="form-field-input"
                    placeholder="Enter dosing instructions"
                  />
                </div>

                <div>
                  <label className="form-field-label">Visit Remark</label>
                  <input
                    type="text"
                    name="remark4"
                    value={formData.remark4}
                    onChange={handleChange}
                    className="form-field-input"
                    placeholder="Enter visit remark"
                  />
                </div>
              </div>

              {formData.diagnosis && symptoms.length > 0 && (
                <div className="symptoms-container">
                  <h3>
                    <Activity className="section-icon" size={24} />
                    Sign & Symptoms <span className="required-star">*</span>
                  </h3>
                  <div className="symptoms-grid">
                    {symptoms.map((symptom) => (
                      <label key={symptom.diagnosis_symptom_id} className="symptom-checkbox-label">
                        <input
                          type="checkbox"
                          className="symptom-checkbox"
                          checked={formData.selectedSymptoms.includes(symptom.diagnosis_symptom_id)}
                          onChange={(e) => {
                            setFormData((prev) => {
                              const selected = new Set(prev.selectedSymptoms);
                              if (e.target.checked) {
                                selected.add(symptom.diagnosis_symptom_id);
                              } else {
                                selected.delete(symptom.diagnosis_symptom_id);
                              }
                              return { ...prev, selectedSymptoms: Array.from(selected) };
                            });
                          }}
                        />
                        <span className="symptom-text">{symptom.symptom}</span>
                      </label>
                    ))}
                  </div>
                  {errors.symptoms && <p className="error-message">{errors.symptoms}</p>}
                </div>
              )}

              {formData.diagnosis && symptoms.length === 0 && (
                <div className="symptoms-container">
                  <h3>
                    <Activity className="section-icon" size={24} />
                    Sign & Symptoms
                  </h3>
                  <div className="loading-text">No symptoms available for this diagnosis.</div>
                </div>
              )}
              {formData.diagnosis && sortedLetters.length > 0 && (
                <div className="symptoms-container">
                  <h3>💊 Medicines</h3>

                  <div className="alphabet-wrapper">
                    {sortedLetters.map((letter) => (
                      <div key={letter} className="alphabet-section">

                        {/* Alphabet Header */}
                        <div className="alphabet-header">{letter}</div>

                        {/* Medicines under alphabet */}
                        <div className="symptoms-grid">
                          {groupedMedicines[letter].map((product) => (
                            <label
                              key={product.product_id}
                              className="symptom-checkbox-label"
                            >
                              <input
                                type="checkbox"
                                className="symptom-checkbox"
                                checked={selectedMedicines.includes(product.product_name)}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedMedicines((prev) => [
                                      ...prev,
                                      product.product_name,
                                    ]);
                                  } else {
                                    setSelectedMedicines((prev) =>
                                      prev.filter(
                                        (name) => name !== product.product_name
                                      )
                                    );
                                  }
                                }}
                              />
                              <span className="symptom-text">
                                {product.product_name}
                              </span>
                            </label>
                          ))}
                        </div>

                      </div>
                    ))}
                  </div>
                </div>
              )}

            </div>
            {/* ================= SECOND DIAGNOSIS ================= */}

            <div style={{ marginTop: "40px" }}>

              <h2 className="form-section-title">
                <Stethoscope className="section-icon" size={28} />
                Second Diagnosis
              </h2>

              <div className="form-grid diagnosis-row">

                <div>
                  <label className="form-field-label">
                    Diagnosis
                  </label>

                  <select
                    name="diagnosis2"
                    value={formData.diagnosis2}
                    onChange={handleChange}
                    className="form-field-select"
                  >

                    <option value="">Select Diagnosis</option>

                    {diagnoses.map((diag) => (

                      <option key={diag.diagnosis_id} value={diag.diagnosis_id}>
                        {diag.name}
                      </option>

                    ))}

                  </select>

                </div>

                <div>

                  <label className="form-field-label">Dosing</label>

                  <input
                    type="text"
                    name="remark2"
                    value={formData.remark2}
                    onChange={handleChange}
                    className="form-field-input"
                  />

                </div>

                <div>

                  <label className="form-field-label">Visit Remark</label>

                  <input
                    type="text"
                    name="remark42"
                    value={formData.remark42}
                    onChange={handleChange}
                    className="form-field-input"
                  />

                </div>

              </div>


              {/* SECOND SYMPTOMS */}

              {formData.diagnosis2 && symptoms2.length > 0 && (

                <div className="symptoms-container">

                  <h3>
                    <Activity className="section-icon" size={24} />
                    Sign & Symptoms
                  </h3>

                  <div className="symptoms-grid">

                    {symptoms2.map((symptom) => (

                      <label key={symptom.diagnosis_symptom_id} className="symptom-checkbox-label">

                        <input
                          type="checkbox"
                          className="symptom-checkbox"
                          checked={formData.selectedSymptoms2.includes(symptom.diagnosis_symptom_id)}
                          onChange={(e) => {

                            setFormData(prev => {

                              const selected = new Set(prev.selectedSymptoms2);

                              if (e.target.checked) {
                                selected.add(symptom.diagnosis_symptom_id);
                              } else {
                                selected.delete(symptom.diagnosis_symptom_id);
                              }

                              return { ...prev, selectedSymptoms2: Array.from(selected) };

                            });

                          }}
                        />

                        <span className="symptom-text">{symptom.symptom}</span>

                      </label>

                    ))}

                  </div>

                </div>

              )}



              {/* SECOND MEDICINES */}

              {formData.diagnosis2 && sortedLetters2.length > 0 && (

                <div className="symptoms-container">

                  <h3>💊 Medicines</h3>

                  <div className="alphabet-wrapper">

                    {sortedLetters2.map(letter => (

                      <div key={letter} className="alphabet-section">

                        <div className="alphabet-header">{letter}</div>

                        <div className="symptoms-grid">

                          {groupedMedicines2[letter].map(product => (

                            <label key={product.product_id} className="symptom-checkbox-label">

                              <input
                                type="checkbox"
                                className="symptom-checkbox"
                                checked={selectedMedicines2.includes(product.product_name)}

                                onChange={(e) => {

                                  if (e.target.checked) {

                                    setSelectedMedicines2(prev => [
                                      ...prev,
                                      product.product_name
                                    ]);

                                  } else {

                                    setSelectedMedicines2(prev =>
                                      prev.filter(name => name !== product.product_name)
                                    );

                                  }

                                }}

                              />

                              <span className="symptom-text">
                                {product.product_name}
                              </span>

                            </label>

                          ))}

                        </div>

                      </div>

                    ))}

                  </div>

                </div>

              )}

            </div>
            <div className="form-section">
              <h2 className="form-section-title">
                <FileText className="section-icon" size={28} />
                Service Mode
              </h2>
              <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
                {["VISIT", "COURIER", "SOMEONE", "VOICE", "VIDEO"].map((option) => (
                  <label
                    key={option}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "6px",
                      padding: "6px 10px",
                      cursor: "pointer",
                      whiteSpace: "nowrap"
                    }}
                  >
                    <input
                      type="radio"
                      name="serviceType"
                      value={option}
                      checked={formData.serviceType === option}
                      onChange={handleChange}
                      style={{ marginRight: "6px" }}
                      required
                    />
                    <span>{option}</span>
                  </label>
                ))}
              </div>
              {errors.serviceType && <p className="error-message">{errors.serviceType}</p>}
            </div>

            <div className="submit-button-container">
              <button
                className="submit-button"
                type="submit"
                disabled={isSubmitting || !formData.serviceType}
              >Submit</button>
            </div>
          </form>
        </main>
      </div>
    </div>
  );
};

export default AddCourse;